import React, { ReactNode, useEffect, useState } from 'react';

import FooterPartial from '@/layouts/new/partials/FooterPartial';
import HeaderPartial from '@/layouts/new/partials/HeaderPartial';
import ChatPopupPage from './partials/ChatPopup';
import { PopupPartial } from './partials/Popup';
import OpenAppBanner from '@/components/ui/OpenAppBanner';

import { PlatForm } from '../shared';
import { AppBannerOs } from '@/libs/openAppBanner';
type NewLayoutProps = {
  isAuth: boolean;
  children: ReactNode;
  keyActive: string;
  isShowNav?: boolean;
  /** ẩn footer lớn (logo, hotline, liên kết) trên mobile — dùng cho trang chat toàn màn hình */
  isHideFooterMobile?: boolean;
  isMobile: boolean;
  isShowBubble?: boolean;
  isShowPopup?: boolean;
  platform: string;
  /** thanh 'Mở app' quyết định ở server (null = không hiện) */
  appBannerOs?: AppBannerOs;
};

const NewLayout = ({
  children,
  isAuth,
  keyActive,
  isShowNav = true,
  isHideFooterMobile = false,
  isShowBubble = true,
  isMobile,
  platform = PlatForm.Web,
  isShowPopup = true,
  appBannerOs = null,
}: NewLayoutProps) => {
  return (
    <main className="tw-relative">
      <div>
        {/* chỉ web mobile, không hiện trong webview của chính app */}
        {platform === PlatForm.Web && <OpenAppBanner initialOs={appBannerOs} />}
        {/* tw-relative: nút menu (☰) trong header định vị absolute theo header,
            không bị lệch khi có thanh "Mở app" phía trên */}
        <div className="tw-relative">
          <HeaderPartial isAuth={isAuth} keyActive={keyActive} platform={platform} />
        </div>
        <div
          className={`tw-h-full ${isShowNav ? 'tw-pb-[calc(5rem_+_env(safe-area-inset-bottom))] md:tw-pb-0' : ''} md:tw-min-h-80-screen `}
        >
          {children}
        </div>
        <FooterPartial
          keyActive={keyActive}
          isAuth={isAuth}
          isShowNav={isShowNav}
          isHideFooterMobile={isHideFooterMobile}
          platform={platform}
        />
      </div>
      <div id="modal-root"></div>
      {isShowPopup && <PopupPartial></PopupPartial>}
      {/* {isClient && <Zalo />} */}

      {isShowBubble && <ChatPopupPage isAuth={isAuth} isMobile={isMobile} />}
    </main>
  );
};

export default NewLayout;
